import React, { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Checkbox,
  Button,
  CircularProgress,
} from '@material-ui/core';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';

import { t, canURL } from '~/helpers';

import * as S from './styles';

export default function Tabela({
  title,
  cells,
  data,
  height,
  size,
  clickOnCell,
  checkbox,
  handleSubmit,
  unique,
  loading,
  defaultChecked,
  atualizandoArq,
}) {
  const [active, setActive] = useState(null);
  const [checked, setChecked] = useState(-1);

  const { internounidatausuario } = useSelector((state) => state.user.configs);

  const permission = canURL().update || internounidatausuario == 'S';

  // Toggle item
  const handleToggleItem = useCallback((value) => {
    setChecked((prev) => (prev === value ? -1 : value));
  }, []);

  // Click cell
  const handleOnClickCell = useCallback(
    (index, item) => {
      clickOnCell(item);
      setActive(index);
    },
    [clickOnCell]
  );

  useEffect(() => {
    setActive(null);
  }, [data]);

  useEffect(() => {
    setChecked(defaultChecked);
  }, [defaultChecked]);

  return (
    <S.WrapperTabela height={height}>
      {loading && (
        <S.WrapperLoading>
          <CircularProgress />
        </S.WrapperLoading>
      )}

      <S.WrapperTitle>
        <Typography>{title}</Typography>

        {checkbox && (
          <Button
            disabled={
              !permission || checked === defaultChecked || atualizandoArq
            }
            onClick={() => handleSubmit(checked)}
            color="primary"
            variant="outlined"
            size="small"
          >
            {t('s.geral.botaoconfirmar')}
          </Button>
        )}
      </S.WrapperTitle>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size={size}>
          <TableHead>
            <TableRow>
              {checkbox && <TableCell padding="checkbox" />}
              {cells.map((cell, index) => (
                <TableCell
                  key={`cell-index-head-${index}`}
                  align={cell.align || 'left'}
                >
                  {cell.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow
                hover
                tabIndex={-1}
                key={`table-row-body-${index}`}
                onClick={() =>
                  checkbox
                    ? handleToggleItem(item[unique])
                    : handleOnClickCell(index, item)
                }
                selected={index === active || checked === item[unique]}
              >
                {checkbox && (
                  <TableCell padding="checkbox">
                    <Checkbox checked={Boolean(checked === item[unique])} />
                  </TableCell>
                )}

                {cells.map((cell, indexKey) => (
                  <TableCell
                    key={`table-cell-body-${indexKey}`}
                    align={cell.align || 'left'}
                  >
                    {cell.converter
                      ? cell.converter(item[cell.id])
                      : item[cell.id]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </S.WrapperTabela>
  );
}

Tabela.propTypes = {
  checkbox: PropTypes.bool,
  title: PropTypes.string.isRequired,
  cells: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      align: PropTypes.string,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  height: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  clickOnCell: PropTypes.func,
  handleSubmit: PropTypes.func,
  unique: PropTypes.string,
  loading: PropTypes.bool,
  defaultChecked: PropTypes.number,
  atualizandoArq: PropTypes.bool,
};

Tabela.defaultProps = {
  checkbox: false,
  height: '100%',
  size: 'medium',
  clickOnCell: () => undefined,
  handleSubmit: () => undefined,
  unique: '',
  loading: false,
  defaultChecked: -1,
  atualizandoArq: false,
};
